VjsAdmin.LicenseFeatures = (function () {
    const init = function () {
        const controller = new FeatureEditController();
        if (!VjsAdmin.hasPermission('platforms.districts.licenses.features.edit')) {
            controller.disableFeatureCheckboxes();
        }
    };

    let FeatureEditController = VjsUtility.Controller.extend({
        events: {
            'click #save-license-features-button': 'clickSaveFeatureButton',
            'click .product-radio': 'clickProductCheckbox',
            'change #use-district-features': 'handleDistrictDefaults',
        },
        clickSaveFeatureButton() {
            const selectedProducts = $('.product-radio:checked')
                .map((i, product) => product.dataset.productId)
                .get();

            const selectedFeatures = $('.feature-checkbox:checked')
                .map((i, feature) => feature.dataset.featureId)
                .get();

            const featureFormData = {
                license_id: document.getElementById('license-feature-form').dataset.licenseId,
                platform_id: document.getElementById('license-feature-form').dataset.platformId,
                use_district_features: $('#use-district-features').is(':checked') ? 1 : 0,
                product_ids: selectedProducts,
                feature_ids: selectedFeatures,
            };

            const req = new VjsUtility.Request();

            req.put(Slim.Router.pathFor('api.license.features.edit'), featureFormData)
                .done(() => {
                    VjsUtility.Notification.success({
                        text: 'License features successfully updated',
                        time: 3500,
                    });
                })
                .fail(() => {
                    VjsUtility.Notification.error({
                        text: 'Error updating license features',
                        time: 3500,
                    });
                });
        },
        clickProductCheckbox(e) {
            const req = new VjsUtility.Request();

            req.get(
                Slim.Router.pathFor('api.product.features.get', {
                    id: e.target.dataset.productId,
                }),
                {
                    platform_id: document.getElementById('license-feature-form').dataset.platformId,
                },
            )
                .done((res) => {
                    const featureIds = res.data.data.features.map((feature) => feature.id);
                    const featureCheckboxes = $('.feature-checkbox');

                    featureCheckboxes.each((i, feature) => {
                        if (featureIds.includes(+feature.dataset.featureId)) {
                            feature.checked = true;
                        } else {
                            feature.checked = false;
                        }
                    });
                })
                .fail(() => {
                    VjsUtility.Notification.error({
                        text: `Cannot get features for product ${e.target.dataset.productName}. 
                                You will need to select features manually.`,
                        time: 3500,
                    });
                });
        },
        handleDistrictDefaults() {
            $('.products-and-features').toggleClass('d-none');
        },
        disableFeatureCheckboxes() {
            $('.feature-checkbox').prop('disabled', true);
        },
    });

    return {
        init,
    };
}());
